import { FieldArray } from "formik";
import React from "react";
import { ProductChoices } from "./ProductChoices";
export function ProductChoicesSelector({ isAuthenticated, toggleModal, AuthModal }) {
    return (React.createElement("div", { className: "k-product--subs choices" },
        React.createElement(FieldArray, { name: "choices" }, ({ replace, form }) => (React.createElement(ProductChoices, { isAuthenticated: isAuthenticated, toggleModal: toggleModal, AuthModal: AuthModal, form: form, replace: replace })))));
}
